import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { HdContentLanguageService } from '../hd-content-language.service';
import { HD_BASICS_INFO_SECTIONS } from './hd-chart-basics-info-metadata';
import { HdChartBasicsInfoService } from './hd-chart-basics-info.service';
import { HdInfoSectionsComponent } from './hd-info-sections.component';
import { HdInfoSectionVm, HdInfoSectionsVm } from './hd-info-sections.models';

/** Het Basics-paneel heeft geen chart-afhankelijke data. */
export type HdBasicsInfoPanelData = Record<string, never>;

/**
 * Info-paneel "Human Design basics": zeven leesdocumenten (wat is HD, de
 * lichaamsgrafiek lezen, niet-zelf, strategie & autoriteit, deconditionering,
 * observatie-oefeningen, hoe met de info om te gaan) met een inhoudstafel-strook.
 */
@Component({
  selector: 'hd-basics-info-panel',
  standalone: true,
  imports: [HdInfoSectionsComponent],
  template: '<hd-info-sections [vm]="vm()" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdBasicsInfoPanelComponent {
  private readonly info = inject(HdChartBasicsInfoService);
  private readonly contentLang = inject(HdContentLanguageService);

  protected readonly vm = computed<HdInfoSectionsVm>(() => {
    const lang = this.contentLang.effectiveLang();
    const t = (key: string) => this.info.text(`basics.${key}`, lang);
    const sections: HdInfoSectionVm[] = HD_BASICS_INFO_SECTIONS.map(key => ({
      key,
      label: t(`sections.${key}`),
      url: this.info.markdownUrl('basics', key, lang),
      isOwn: false,
      badges: [],
      facts: [],
    }));
    return {
      title: t('title'),
      strip: {
        label: t('stripLabel'),
        chips: sections.map(section => ({ sectionKey: section.key, label: section.label })),
      },
      sections,
    };
  });
}
